module.exports = "/build/images/icons-public.e2166ae7.svg";


//////////////////
// WEBPACK FOOTER
// ./html/images/icons-public.svg
// module id = WIg7
// module chunks = 0